import * as preact from "preact";

import UserWordModel from "models/UserWordModel";
import models from "models/models";
import { ChallengeProps } from "practiceUtils";
import * as languageMap from "shared/languageMap";

interface State {}

class IntroChallengeView extends preact.Component<ChallengeProps, State> {
  userWords: Backbone.Collection<UserWordModel>;

  render() {
    const { userWord, completedCallback, reportRecallEase } = this.props;

    return (
      <div>
        <h2>Write a sentence using "{userWord.get("word")}"</h2>
        <div>
          <p>Here's an example sentence:</p>
          {userWord.get("contexts") ? (
            <p>{userWord.get("contexts")[0].text}</p>
          ) : (
            <p>No contexts!</p>
          )}
        </div>
        <p>
          <input
            type="text"
            placeholder={`Type in ${
              languageMap.map[models.user.get("currentLearningLanguage")]
                .english
            }`}
          ></input>
          <button
            onClick={() => {
              completedCallback({
                type: "show-feedback",
                correct: "yes",
              });
              reportRecallEase(2);
            }}
          >
            Self-report: Hard
          </button>
          <button
            onClick={() => {
              completedCallback({
                type: "show-feedback",
                correct: "yes",
              });
              reportRecallEase(4);
            }}
          >
            Self-report: Easy
          </button>
        </p>
      </div>
    );
  }
}

export default IntroChallengeView;
